var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"visible":_vm.flag,"width":"800px","before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.flag=$event}}},[_c('el-scrollbar',{staticStyle:{"height":"70vh"}},[_c('um-url',{attrs:{"url":_vm.argeeHtmlUrl}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }